export default "__VITE_ASSET__DwEvs4HV__"